import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SHARED_WALLET_FEATURE_KEY, SharedWalletState } from './wallet.reducer';

export const selectSharedWalletState = createFeatureSelector<SharedWalletState>(
  SHARED_WALLET_FEATURE_KEY
);

// Wallet Whitelist Addresses Selectors
export const selectWalletWhitelistAddresses = createSelector(
  selectSharedWalletState,
  state => state.walletWhitelistAddresses
);

export const selectWalletWhitelistAddressesLoading = createSelector(
  selectSharedWalletState,
  state => state.walletWhitelistAddressesLoading
);

export const selectWalletWhitelistAddressesError = createSelector(
  selectSharedWalletState,
  state => state.walletWhitelistAddressesError
);

export const selectWalletWhitelistAddressesPagination = createSelector(
  selectSharedWalletState,
  state => state.walletWhitelistAddressesPagination
);

export const selectWalletDetails = createSelector(
  selectSharedWalletState,
  state => state.walletDetails
);

export const selectWalletDetailsLoading = createSelector(
  selectSharedWalletState,
  state => state.walletDetailsLoading
);

export const selectWalletDetailsError = createSelector(
  selectSharedWalletState,
  state => state.walletDetailsError
);
